import { heroData } from '@/mocks/cinema';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20night%20scene%20with%20warm%20spotlight%20illuminating%20a%20minimalist%20space%2C%20abstract%20film%20reel%20textures%2C%20deep%20charcoal%20and%20amber%20tones%2C%20dramatic%20shadows%2C%20luxurious%20theater%20atmosphere%2C%20soft%20glow%20effects%2C%20elegant%20composition&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="夜猫电影院背景"
          className="w-full h-full object-cover opacity-60"
          onError={(e) => {
            (e.target as HTMLElement).style.display = 'none';
          }}
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-background-50" />

      <div className="relative w-full section-container px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/15 text-primary-400 text-sm font-medium mb-6 whitespace-nowrap">
              {heroData.tag}
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-foreground-50 leading-tight mb-4">
              {heroData.h1}
              <br />
              <span className="text-gradient-warm">{heroData.h1Suffix}</span>
            </h1>
            <p className="text-lg md:text-xl text-primary-400 font-medium mb-6">
              {heroData.slogan}
            </p>
            <p className="text-foreground-400 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-foreground-100">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href={heroData.primaryCta.href}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium rounded-full transition-all duration-200 text-center whitespace-nowrap cursor-pointer text-sm"
              >
                {heroData.primaryCta.label}
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="w-full sm:w-auto px-8 py-3 border border-foreground-300/30 hover:border-primary-500/50 text-foreground-300 hover:text-primary-400 font-medium rounded-full transition-all duration-200 text-center whitespace-nowrap cursor-pointer text-sm"
              >
                {heroData.secondaryCta.label}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden border border-background-200/30">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20cinema%20composition%20with%20floating%20golden%20particles%2C%20warm%20spotlight%20effect%2C%20dark%20luxurious%20background%2C%20film%20aesthetic%2C%20elegant%20and%20mysterious%20atmosphere%2C%20minimalist%20design%2C%20dramatic%20lighting&width=800&height=1000&seq=hero-visual-01&orientation=portrait"
                alt="夜猫电影院主视觉"
                className="w-full h-auto object-cover aspect-[4/5] object-top"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse" />
                <span className="text-xs text-foreground-200 bg-background-950/60 px-3 py-1 rounded-full">
                  正在热播中
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}